<template>
	<div>
		<v-layout row>
			<v-flex>
				<v-card>
					<v-list two-line subheader>
						<v-subheader inset>Custom Review Templates</v-subheader>

						<v-list-tile v-for="template in templates" :key="template.id" avatar @click="onSelection(template.id)">
							<v-list-tile-avatar>
								<v-icon class="amber white--text">mdi-file-document-edit-outline</v-icon>
							</v-list-tile-avatar>

							<v-list-tile-content>
								<v-list-tile-title>{{ template.name }}</v-list-tile-title>
								<!-- <v-list-tile-sub-title>Custom Template</v-list-tile-sub-title> -->
							</v-list-tile-content>

							<v-list-tile-action v-if="isAdmin">
								<v-btn icon ripple @click="onEditClicked(template.id)">
									<v-icon color="grey lighten-1">edit</v-icon>
								</v-btn>
							</v-list-tile-action>

							<v-list-tile-action v-if="isAdmin">
								<v-btn icon ripple @click.stop="onDeleteClicked(template.id)">
									<v-icon color="grey lighten-1">delete</v-icon>
								</v-btn>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	export default {
		props: {
			templates: {
				required: true,
				type: Array
			},
			isAdmin: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				search: null
			};
		},
		methods: {
			onSelection(id) {
				this.$emit('onSelection', id);
			},
			onEditClicked(id) {
				this.$emit('onEditClicked', id);
			},
			onDeleteClicked(id) {
				this.$emit('onDeleteClicked', id);
			}
		}
	};
</script>

<style scoped></style>
